import { getOrders } from '../services/accountService'

function fetchOrders(accountNumber, type) {
  return getOrders(accountNumber, type)
}

export default fetchOrders
